import 'sticky-kit/dist/sticky-kit.min.js';
import anime from 'animejs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger);

// text reveal using gsap
let showAnimationMarkers = false

if (ajax_object.env !== 'production') {
  showAnimationMarkers = true
}

function toggleAnimation() {
  gsap.utils.toArray('.reveal-group').forEach(group => {
    gsap.from(group.querySelectorAll('.reveal-item'), {
      opacity: 0,
      y: 35,
      duration: 1,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: group,
        start: 'top 85%',
        scrub: false,
        markers: showAnimationMarkers,
      },
    });
  });

  gsap.set('.reveal', { y: 40, opacity: 0 });
  ScrollTrigger.batch('.reveal', {
    onEnter: (batch) => {
      gsap.fromTo(batch,
        // Starting state (from)
        { opacity: 0, y: 40 },
        // Ending state (to)
        { opacity: 1, y: 0, duration: 1, stagger: { each: 0.2, from: 'start' }, ease: 'power2.out' }
      );
    },
    start: 'top 85%',
    markers: showAnimationMarkers,
  });


  ScrollTrigger.batch('.donut', {
    interval: 0,
    batchMax: 15,
    start: 'top 90%',
    delay: 5,
    onEnter: batch => {
      batch.forEach(element => {
        if (element.classList.contains('donut')) {
          element.classList.add('revealed');
        }
      });
    },
  });
}

// disable form submit button in development
if (ajax_object.env === 'development') {
  const submitButton = document.querySelector('.wpcf7-submit')
  if (submitButton) {
    submitButton.setAttribute('disabled', true);
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages

    if ($('.js__menubar--sticky').length) {
      $('.js__menubar--sticky').stick_in_parent({
        bottoming: true,
        offset_top: 0,
      });
    }

    // Mobile Menu
    $(document)
      .off('click', '.js__openmenu')
      .on('click', '.js__openmenu', function (e) {
        e.preventDefault();
        togglemenu();
      });

    // toggle Menu - toggle bodyclass
    function togglemenu() {
      // change to keep menu toggle aria state in sync
      const menuToggleButton = document.querySelector('.js__openmenu');
      if ($('#body-classes').hasClass('mobilemenu--open')) {
        anime({
          targets: '#menu-mainmenu > li',
          translateX: [0, 100],
          opacity: [1, 0],
          easing: 'easeInOutQuad',
          loop: false,
          duration: 100,
          delay: anime.stagger(50),
          complete: function () {
            $('#body-classes').removeClass('mobilemenu--open');
            $('html').removeClass('noscroll');
            // change aria attributes because menu is closed
            if (menuToggleButton) {
              menuToggleButton.setAttribute('aria-expanded', 'false');
              menuToggleButton.setAttribute('aria-label', 'Menü öffnen');
            }
          },
        });
      } else {
        $('#body-classes').addClass('mobilemenu--open');
        $('html').addClass('noscroll');
        // change aria attributes because menu is open
        if (menuToggleButton) {
          menuToggleButton.setAttribute('aria-expanded', 'true');
          menuToggleButton.setAttribute('aria-label', 'Menü schließen');
        }

        anime({
          targets: '#menu-mainmenu > li',
          translateX: [-100, 0],
          opacity: [0, 1],
          easing: 'easeInOutQuad',
          loop: false,
          duration: 300,
          delay: anime.stagger(100),
          complete: function () { },
        });
      }
      return false;
    }

    // Accordions
    var accordions = document.querySelectorAll('.kfh-accordion--container');

    function accordionToggle(accordionActiveElement, accordions) {
      var clickOnActiveElement = false;

      if (accordionActiveElement.classList.contains('active')) {
        clickOnActiveElement = true;
      }

      accordions.forEach((accordion) => {
        accordion.classList.remove('active');
        // change to reset accordion button state for accessibility
        let accordionButton = accordion.querySelector('.kfh-accordion--header');
        if (accordionButton) {
          accordionButton.setAttribute('aria-expanded', 'false');
        }

        if (clickOnActiveElement == true) {
          var accordionActiveElementContent = accordionActiveElement.querySelectorAll('.kfh-accordion--content');
          accordionActiveElementContent[0].style.height = 0;
          // change aria-hidden because accordion content is closed
          accordionActiveElementContent[0].setAttribute('aria-hidden', 'true');
          return;
        }

        let thisAccordionContent = accordion.querySelectorAll(
          '.kfh-accordion--content'
        );

        anime({
          targets: thisAccordionContent[0],
          height: 0,
          easing: 'easeOutExpo',
          loop: false,
          duration: 400,
          complete: function () {
            accordionActiveElement.classList.add('active');
            // change to mark active accordion button as expanded
            let activeAccordionButton = accordionActiveElement.querySelector('.kfh-accordion--header');
            if (activeAccordionButton) {
              activeAccordionButton.setAttribute('aria-expanded', 'true');
            }
            var accordionActiveElementContent =
              accordionActiveElement.querySelectorAll('.kfh-accordion--content');
            // change aria-hidden because accordion content is open
            accordionActiveElementContent[0].setAttribute('aria-hidden', 'false');

            accordionActiveElementContent[0].style.height = 'auto';
            let height = accordionActiveElementContent[0].clientHeight;
            accordionActiveElementContent[0].style.height = 0;

            anime({
              targets: accordionActiveElementContent,
              height: [0, height],
              easing: 'easeOutExpo',
              loop: false,
              duration: 200,
              complete: function () {
                // todo: add hash to url?
              },
            });
          },
        });
      });
    }

    if (accordions.length) {
      // accordion click handler
      accordions.forEach((accordion) => {
        let accordionHeader = accordion.querySelectorAll(
          '.kfh-accordion--header'
        );
        // change to set initial accordion aria states
        let accordionContent = accordion.querySelectorAll('.kfh-accordion--content');
        if (accordionHeader[0]) {
          accordionHeader[0].setAttribute('aria-expanded', 'false');
        }
        if (accordionContent[0]) {
          accordionContent[0].setAttribute('aria-hidden', 'true');
        }

        accordionHeader[0].addEventListener('click', function (event) {
          event.preventDefault();
          accordionToggle(this.parentNode, accordions);
        });
      });

      // toggle first accordion
      // accordionToggle(accordions[0], accordions);
    }

    function desktopMenu() {
      $('#body-classes').removeClass('mobilemenu--open');
      $('html, body').removeClass('noscroll');
      $('#menu-mainmenu > li').css('transform', 'initial');
      $('#menu-mainmenu > li').css('opacity', 1);
    }

    // Header Slider Block
    var headersliderContainer = document.querySelectorAll(
      '.swiper-container.headerslider'
    );

    if (headersliderContainer) {
      headersliderContainer.forEach(function (headersliderContainer) {
        // let swiperID = houseintroThumbsContainer.getAttribute('data-swiperid');

        let headersliderSwiper = new Swiper(headersliderContainer, {
          direction: 'horizontal',
          freeMode: false,
          spaceBetween: 60,
          slidesPerView: 1,
          loop: false,
          roundLengths: true,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          on: {
            init: function () {
              $(this.el).find('.swiper-slide').removeClass('kfh-slide-hidden');
            },
          },
        });

        headersliderSwiper.update();
      });
    }

    // Sllider Quote Block
    var quotesliderContainer = document.querySelectorAll(
      '.swiper-container.quoteslider'
    );

    if (quotesliderContainer) {
      quotesliderContainer.forEach(function (quotesliderContainer) {
        // let swiperID = houseintroThumbsContainer.getAttribute('data-swiperid');

        let quotesliderSwiper = new Swiper(quotesliderContainer, {
          direction: 'horizontal',
          freeMode: false,
          spaceBetween: 60,
          slidesPerView: 1,
          loop: false,
          roundLengths: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        });

        quotesliderSwiper.update();
      });
    }

    // JavaScript to be fired on all pages, after page specific JS is fired
    $(window).on('load resize', function () {
      if ($(window).width() >= 768) {
        desktopMenu();
      } else {
        // console.log('mobilemenu');
      }
    });





    // counter up using gsap
    function counterUp() {
      const counters = document.querySelectorAll('.counterup');

      counters.forEach(counter => {
        gsap.from(counter, {
          textContent: 0,
          duration: 3,
          ease: 'power1.in',
          snap: { textContent: 1 },
          scrollTrigger: {
            trigger: counter,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        });
      });
    }

    counterUp();

  },
  finalize() {
    toggleAnimation();
  },
}
